module.exports = __webpack_public_path__ + "img/airtel_logo.5b8acd2f.svg";